import React from "react";
import {
	Box,
	Container,
	Grid,
	Typography,
	Card,
	CardContent,
	CardMedia,
	Divider,
	Button,
} from "@mui/material";
import { MdCall } from "react-icons/md";

// Sample support features data
const supportFeatures = [
	{
		title: "24/7 Customer Support",
		description:
			"Our dedicated support team is available around the clock to assist you with any trading queries or technical issues.",
		image:
			"https://images.unsplash.com/photo-1608532767314-7f072b2a5f1c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
	},
	{
		title: "Secure Transactions",
		description:
			"We prioritize your security with advanced encryption and secure wallet integrations, ensuring your assets are protected at all times.",
		image:
			"https://images.unsplash.com/photo-1617726451764-7a2f7cc0be9f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
	},
	{
		title: "Educational Resources",
		description:
			"Access comprehensive guides, tutorials, and market analysis to help you make informed trading decisions.",
		image:
			"https://images.unsplash.com/photo-1609697983218-3f7fef8f7f69?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
	},
];

// Support Page component
const SupportPage = () => {
	return (
		<Box sx={{ py: 8 }}>
			<Container maxWidth="lg">
				{/* Header Section */}

				<Box
					sx={{
						bgcolor: "white",
						color: "black",
						py: 8,
						mt: "4rem",
						textAlign: "center",
						position: "relative",
						mb: "3rem",
					}}>
					<Typography
						variant="h3"
						gutterBottom
						sx={{ fontWeight: "bold", px: "1rem" }}>
						Support
					</Typography>
					<Divider
						sx={{
							bgcolor: "black",
							my: "0.5rem",
							width: "5rem",
							marginX: "auto",
						}}
					/>
					<Typography
						variant="h6"
						sx={{
							maxWidth: 600,
							marginX: "auto",
							mb: "5rem",
							color: "#27282A",
							px: "2rem",
						}}>
						Our dedicated support team is here to assist you with any questions
						or issues. Contact us anytime for expert help and guidance.
					</Typography>
					<div class="custom-shape-divider-bottom-1760315014">
						<svg
							data-name="Layer 1"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 1200 120"
							preserveAspectRatio="none">
							<rect x="1200" height="3.6"></rect>
							<rect height="3.6"></rect>
							<path
								d="M0,0V3.6H580.08c11,0,19.92,5.09,19.92,13.2,0-8.14,8.88-13.2,19.92-13.2H1200V0Z"
								class="shape-fill"></path>
						</svg>
					</div>
				</Box>
				{/* <Typography
					variant="h3"
					align="center"
					gutterBottom
					sx={{ fontWeight: "bold", mb: 4, color: "#1E3A8A" }}>
					We're Here to Support Your Crypto Trading Journey
				</Typography> */}
				<Typography variant="h6" align="center" sx={{ mb: 6, color: "white" }}>
					Our dedicated support team and resources are designed to help you
					navigate the crypto markets with confidence and security.
				</Typography>
				{/* Support Features */}
				<Grid container spacing={4}>
					{supportFeatures.map((feature, index) => (
						<Grid item xs={12} md={4} key={index}>
							<Card
								sx={{
									height: "100%",
									display: "flex",
									flexDirection: "column",
									boxShadow: 3,
									"&:hover": {
										boxShadow: 6,
									},
								}}>
								{/* <CardMedia
									component="img"
									height="180"
									image={feature.image}
									alt={feature.title}
									sx={{ objectFit: "cover" }}
								/> */}
								<CardContent sx={{ flexGrow: 1 }}>
									<Typography
										variant="h5"
										gutterBottom
										sx={{ color: "#1E3A8A", fontWeight: "bold" }}>
										{feature.title}
									</Typography>
									<Typography variant="body1" color="textSecondary">
										{feature.description}
									</Typography>
								</CardContent>
							</Card>
						</Grid>
					))}
				</Grid>
				{/* Call to Action */}
				<Box sx={{ textAlign: "center", mt: 8 }}>
					<Typography
						variant="h4"
						gutterBottom
						sx={{ fontWeight: "bold", mb: 2, color: "#1E3A8A" }}>
						Need Personalized Assistance?
					</Typography>
					<Typography variant="h6" gutterBottom sx={{ mb: 4, color: "white" }}>
						Contact our support team via any of the provided chat support for
						tailored guidance on your crypto trading experience.
					</Typography>
					{/* <Box sx={{ pt: "1rem" }}>
						<ul className="pl-[1rem]  text-black  mt-[1rem] flex  flex-col gap-[0.2rem]">
							<li>
								<span className="font-bold">
									{" "}
									<MdCall className="inline-block" /> UK :
								</span>{" "}
								<span className="font-serif  tracking-wide">
									{" "}
									+447441905174
								</span>
							</li>
							<li>
								{" "}
								<span className="font-bold">
									{" "}
									<MdCall className="inline-block" /> Canada :
								</span>{" "}
								<span className="font-serif  tracking-wide">
									+1{"("}438{")"}266-1222
								</span>
							</li>
							<li>
								{" "}
								<span className="font-bold">
									{" "}
									<MdCall className="inline-block" /> USA :
								</span>
								<span className="font-serif  tracking-wide">
									{" "}
									+1{"("}909{")"}505-3959
								</span>
							</li>
						</ul>
					</Box> */}
					{/* <Button
						variant="contained"
						size="large"
						color="primary"
						sx={{ px: 4, py: 1.5 }}
						href="#contact">
						Get Support Now
					</Button> */}
				</Box>
			</Container>
		</Box>
	);
};

export default SupportPage;
